<ng-template #newLeadDlgTmpl>
    <div
        id="call-note"
        class="d-flex flex-column"
        [ngClass]="notePanelClass">
        <div class="header px-3 py-2">
            <h4 class="fs-5 pt-1 lh-lg m-0">New Note</h4>
        </div>
        <div class="flex-grow-1 px-3 py-2 agent-list-cont">
            <label class="padded-top-gray-label">Note:</label>
            <editor
                [(ngModel)]="noteData.content"
                [apiKey]="this.env.tinymceApiKey"
                [init]="tinyInit"></editor>
            <label class="padded-top-gray-label">File:</label>
            <div *ngIf="noteData.files.length">
                <div
                    class="note-file"
                    *ngFor="let file of noteData.files">
                    <img
                        class="note-file-img"
                        src="{{ getFilePath(file) }}" />
                    <div
                        class="note-file-delete"
                        (click)="removeFile(file)">
                        <img src="/assets/images/icon-menu-close.svg" />
                    </div>
                </div>
            </div>
            <div
                class="dropzone dropzone-container"
                [dropzone]="uploadConfig"
                (error)="onUploadError($event)"
                (success)="onUploadSuccess($event)"
                (totalUploadProgress)="canPostANote = $event[0] === 100">
                <div
                    class="dz-message dz-message-sm mx-4"
                    data-dz-message>
                    <svg-icon
                        class="hover"
                        src="assets/images/image-upload.svg"></svg-icon>
                    <p>+ Select file <strong>from computer</strong> or use <strong>drag & drop</strong> (JPG,PNG)</p>
                </div>
                <div class="dz-details">
                    <div class="dz-filename"><span data-dz-name></span></div>
                    <div
                        class="dz-size"
                        data-dz-size></div>
                    <img data-dz-thumbnail />
                </div>
            </div>
        </div>
    </div>
</ng-template>
